<template>
  <div
    ref="modal"
    class="modal trailer-modal fade"
    id="vue-trailer-modal"
    tabindex="-1"
    aria-label="Trailer Modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div v-if="movie?.trailerContent">
            <div :id="`mediaplayer_${movie.detailId}`">
              <div>
                <iframe
                  class="ratio ratio-16x9 w-100"
                  :src="movie.trailerContent"
                  allowfullscreen
                  sandbox="allow-scripts allow-presentation allow-same-origin allow-popups"
                  allow="autoplay; fullscreen; picture-in-picture; xr-spatial-tracking; encrypted-media; clipboard-write"
                >
                </iframe>
              </div>
            </div>
          </div>
          <div v-else-if="movie?.trailer && movie.trailerType">
            <div :id="`mediaplayer_${movie.trailer}`">
              <div>
                <iframe
                  class="ratio ratio-16x9 w-100 cmplazyload"
                  id="youtube-trailer"
                  width="1106"
                  height="628"
                  data-cmp-vendor="s30"
                  src="about:blank"
                  :data-cmp-src="`https://www.youtube-nocookie.com/embed/${movie.trailer}`"
                  data-cmp-preview-text="Dieser Inhalt wird von Youtube bereit gestellt. Wenn Sie den Inhalt aktivieren, werden ggf. personenbezogene Daten verarbeitet und Cookies gesetzt."
                  data-cmp-preview-checkbox=" Youtube immer akzeptieren"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                >
                </iframe>
              </div>
            </div>
          </div>
          <div v-else>
            <p class="no-trailer">Kein Trailer vorhanden</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const movie = ref(null);
const modal = ref(null);

const handleTrailerPlay = (event) => {
  movie.value = event.detail;
  if (modal.value && movie.value) {
    window.bootstrap.Modal.getOrCreateInstance(modal.value).show();
  }
};

const handleModalHidden = () => {
  movie.value = null;
};

onMounted(() => {
  document.addEventListener("trailerplayer-play", handleTrailerPlay);
  modal.value.addEventListener("hidden.bs.modal", handleModalHidden);
});

onUnmounted(() => {
  document.removeEventListener("trailerplayer-play", handleTrailerPlay);
  modal.value.removeEventListener("hidden.bs.modal", handleModalHidden);
});
</script>

<style scoped>
.no-trailer {
  text-align: center;
  padding: 40px;
  opacity: 0.6;
  margin: 0;
}
</style>
